import React from 'react'
import { withRouter } from 'react-router-dom'
import MarketMasterEditor from './market/MarketMasterEditor'
import ClientPricingEditor from './client/ClientPricingEditor'

const PricingDetailsPanel = ({ match }) => {
	const clientId = match && match.params ? match.params.clientId : null
	const market = match && match.params ? match.params.market : null

	return clientId ? (
		<ClientPricingEditor />
	) : (
		<MarketMasterEditor market={market} />
	)
}

export default withRouter(PricingDetailsPanel)
